import { useController, useFormContext } from "react-hook-form";

import { RichTextEditor, RichTextEditorProps } from "./base";

interface ControlledRichTextEditorProps extends RichTextEditorProps {
  rules?: {
    required?: { value: boolean; message: string };
    minLength?: { value: number; message: string };
    maxLength?: { value: number; message: string };
    validate?: (val: string) => string | undefined;
    pattern?: { value: RegExp; message: string };
  };
}

export function ControlledRichTextEditor({
  name,
  label = "",
  rules = {},
  placeholderKeys = [],
}: ControlledRichTextEditorProps) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name, control, rules });
  const required = rules.required?.value === true;

  return (
    <RichTextEditor
      label={label}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      editorRef={field.ref}
      error={fieldState.error?.message}
      required={required}
      placeholderKeys={placeholderKeys}
    />
  );
}
